import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ملفات الترجمة
import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  fr: {
    translation: fr
  },
  en: {
    translation: en
  },
  ar: {
    translation: ar
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // تعيين الفرنسية كلغة افتراضية
    fallbackLng: 'fr',
    debug: false, // تعطيل رسائل التطوير
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    // إعدادات إضافية لضمان عمل الترجمات
    react: {
      useSuspense: false
    },
    
    // إعدادات إضافية لضمان عمل الترجمات
    keySeparator: '.',
    nsSeparator: ':'
  });

export default i18n;
